import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1440,
    margin: '0 auto',
    background: '#ffffff',
    color: theme.palette.secondary.main,
    padding: theme.spacing(4),
    paddingTop: 0,
    position: 'relative',
    zIndex: 1,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(10),
  },
  introContainer: {
    marginBottom: 60,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
  },
  heading: {
    color: theme.palette.secondary.light,
    ...theme.typography.h2,
    marginTop: 12,
    marginBottom: 12,
    [theme.breakpoints.up('md')]: {
      marginTop: 4,
    },
  },
  overline: {
    color: theme.palette.primary.dark,
  },
  supportiveCopy: {
    maxWidth: 900,
    marginBottom: 10,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  ctaContainer: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  cardGrid: {
    gap: '1rem',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}))

export default useStyles
